import React, { useEffect, useState } from 'react'
import Container from './../Container/Container';



export default function Courses() {
    const [courses, setCourses] = useState([]);



    useEffect(() => {
        fetch('information.json')
            .then(response => response.json())
            .then(data => setCourses(data));
    }, []);


    return (
        <div>
            <h3 className="text-center text-warning mt-2 mb-2">
                All Available Courses
            </h3>
            <div className="row justify-content-center">
                {
                    courses.map(course =>
                        <Container key={course.id} obj={course}>
                        </Container>)
                }
            </div>
        </div>
    )
}
